import { LoanDesistReason } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from '../../../shared/components/Text';

export const LoanDesistReasonOptions = Object.values(LoanDesistReason).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
